import { render, staticRenderFns } from "./accountPassword.vue?vue&type=template&id=4012558c&scoped=true"
import script from "./accountPassword.vue?vue&type=script&lang=js"
export * from "./accountPassword.vue?vue&type=script&lang=js"
import style0 from "./accountPassword.vue?vue&type=style&index=0&id=4012558c&prod&lang=less&scoped=true"
import style1 from "./accountPassword.vue?vue&type=style&index=1&id=4012558c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012558c",
  null
  
)

export default component.exports